import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const STATUS = {
  nuovo_donatore: { label: "Nuovo donatore", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  nuova: { label: "Donazione nuova", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  gia_registrata: { label: "Già registrata", cls: "bg-stone-100 text-stone-600 border-stone-200" },
  importo_diverso: { label: "Importo diverso", cls: "bg-red-50 text-red-700 border-red-200" },
  dubbio: { label: "Donatore da confermare", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  senza_importo: { label: "Senza importo", cls: "bg-stone-50 text-stone-400 border-stone-200" },
};

const OPTIONS = {
  nuovo_donatore: [["crea", "Crea donatore e donazione"], ["ignora", "Ignora"]],
  nuova: [["aggiungi", "Registra donazione"], ["ignora", "Ignora"]],
  gia_registrata: [["ignora", "Salta (già presente)"], ["aggiungi", "Aggiungi comunque"]],
  importo_diverso: [["correggi", "Correggi importo registrato"], ["aggiungi", "Aggiungi come seconda donazione"], ["ignora", "Ignora"]],
  dubbio: [["ignora", "Ignora"], ["crea", "Crea nuovo donatore"]],
  senza_importo: [["ignora", "Ignora"]],
};

const eur = (n) => `€ ${Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2 })}`;

export function ReconRow({ r, decision, onChange }) {
  const st = STATUS[r.status];
  const opts = [...OPTIONS[r.status].filter(([v]) => !(r.status === "importo_diverso" && v === "correggi" && r.existing.length > 1)),
    ...(r.status === "importo_diverso" && r.existing.length > 1 ? r.existing.map((p) => [`correggi:${p.id}`, `Correggi quella da ${eur(p.amount)}`]) : []),
    ...(r.status === "dubbio" ? r.candidates.map((c) => [`collega:${c.id}`, `È ${c.name}${c.cf ? ` (${c.cf})` : ""}`]) : [])];
  const value = decision ? (decision.action === "collega" ? `collega:${decision.donor_id}` : decision.payment_id ? `correggi:${decision.payment_id}` : decision.action)
    : (r.status === "importo_diverso" && r.existing.length > 1 ? `correggi:${r.existing[r.existing.length - 1].id}` : r.action);
  const set = (v) => onChange(v.startsWith("collega:") ? { action: "collega", donor_id: v.slice(8) }
    : v.startsWith("correggi:") ? { action: "correggi", payment_id: v.slice(9) } : { action: v });
  return (
    <div className={`px-4 py-3 border-b border-stone-100 flex flex-wrap items-center gap-3 ${r.status === "importo_diverso" ? "bg-red-50/40" : r.status === "dubbio" ? "bg-amber-50/40" : ""}`} data-testid={`recon-row-${r.row}`}>
      <div className="w-10 text-[11px] text-stone-400">#{r.row}</div>
      <div className="flex-1 min-w-[180px]">
        <div className="font-medium text-sm text-[#1C352D]">{r.last_name} {r.first_name}</div>
        <div className="text-[11px] text-stone-500">{r.cf || "CF assente"}{r.donor_name ? ` · in archivio: ${r.donor_name}` : ""}</div>
      </div>
      <div className="w-28 text-right">
        <div className="font-semibold text-sm" data-testid={`recon-amount-${r.row}`}>{eur(r.amount)}</div>
        {r.existing?.length > 0 && <div className="text-[11px] text-stone-500">registrato: {r.existing.map((p) => eur(p.amount)).join(" + ")}</div>}
      </div>
      <span className={`text-[10px] rounded-full border px-2 py-0.5 ${st.cls}`} data-testid={`recon-status-${r.row}`}>{st.label}</span>
      <div className="w-full sm:w-64">
        <Select value={value} onValueChange={set} disabled={r.status === "senza_importo"}>
          <SelectTrigger className="h-8 text-xs" data-testid={`recon-action-${r.row}`}><SelectValue/></SelectTrigger>
          <SelectContent>{opts.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
        </Select>
      </div>
    </div>
  );
}
